import { axiosV2 } from "config/@axios";
import {
  denormalize,
  findByPath
} from "pages/Folders/helpers/denormalizeFolder";

export const FETCH_FOLDERS = "folderActions::fetchFolders";
export const FETCH_FOLDERS_SUCCESS = "folderActions::fetchFoldersSuccess";
export const FETCH_FOLDERS_FAILED = "folderActions::fetchFoldersFailed";
export const UPDATE_NAME = "folderActions::updateName";
export const UPDATE_RETENTION = "folderActions::updateRetention";
export const MOVE_ITEM = "folderActions::moveItem";
export const DELETE_ITEM = "folderActions::deleteItem";
export const CHANGE_COLOR = "folderActions::changeColor";
export const UPDATE_UNREAD_COUNT = "folderActions::updateUnreadCount";
export const UPDATE_STATUS = "folderActions::updateStatus";

export const FETCH_SILENT_FOLDER = "folderActions::fetchSilentFolder";
export const FETCH_SILENT_FOLDER_FAILED =
  "folderActions::fetchSilentFolderFailed";

export const fetchFolders =
  (silent = false, view = "message") =>
  dispatch => {
    dispatch({
      type: FETCH_FOLDERS,
      payload: {
        silent
      }
    });

    let url = `/folders?search_type=tree&view=${view}`;

    return axiosV2
      .get(url)
      .then(response => {
        dispatch({
          type: FETCH_FOLDERS_SUCCESS,
          payload: {
            folders: response.data
          }
        });
      })
      .catch(err => {
        dispatch({
          type: FETCH_FOLDERS_FAILED,
          payload: {
            errorText: err.errorMessage
          }
        });
      });
  };

export const fetchSilentFolder =
  ({ id = null, name = null }) =>
  (dispatch, getState) => {
    if (name) {
      const state = getState();
      const folders = state.entities.folders;

      const allItems = denormalize({
        allIds: folders.allIds,
        byId: folders.byId
      });
      const obj = findByPath(allItems, name.toLowerCase());

      id = obj?.id;
      if (!id) {
        return Promise.resolve(false);
      }
    }

    dispatch({ type: FETCH_SILENT_FOLDER });
    return axiosV2
      .get(`/folders/${id}?read_type=info`)
      .then(response => {
        const result = response.data;
        dispatch(
          updateUnreadCount(id, {
            unread: result.unread,
            count: result.count,
            size: result.size
          })
        );
      })
      .catch(err => {
        dispatch({
          type: FETCH_SILENT_FOLDER_FAILED,
          payload: { message: err.errorMessage }
        });
      });
  };

export const updateName = (folderId, newName, absFolderPath) => ({
  type: UPDATE_NAME,
  payload: {
    folderId,
    newName,
    absFolderPath
  }
});

export const updateRetention = (folderId, retention) => ({
  type: UPDATE_RETENTION,
  payload: {
    folderId,
    retention
  }
});

export const updateUnreadCount = (folderId, { unread, count, size }) => ({
  type: UPDATE_UNREAD_COUNT,
  payload: {
    folderId,
    unread,
    count,
    size
  }
});

export const moveItem = (folderId, prevParentFolder, parentFolderId) => ({
  type: MOVE_ITEM,
  payload: {
    folderId,
    prevParentFolder,
    parentFolderId
  }
});

export const deleteItem = folder => ({
  type: DELETE_ITEM,
  payload: {
    folder
  }
});

export const changeColor = ({ folderId, color }) => ({
  type: CHANGE_COLOR,
  payload: {
    folderId,
    color
  }
});

export const updateStatus = (folderId, status) => ({
  type: UPDATE_STATUS,
  payload: {
    folderId,
    status
  }
});
